import { FunctionComponent, ReactNode, useCallback } from 'react'

import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'
import useViewportTracking from '@hooks/useViewportTracking'
import { stripHtml } from '@hooks/useTracking/utils'
import useTracking, { TrackingFnType } from '@hooks/useTracking'

const StyledTitle = styled.div`
  ${({
    theme: {
      fonts: { goodOTNarrow },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      font-size: 24px;
      margin-top: 50px;
      margin-bottom: 20px;

      font-family: ${goodOTNarrow};

      width: 100%;
      font-weight: 600;
      color: ${grey_100};
      margin: 50px 0 20px 0;

      ${mobileCSS(css`
        font-size: 22px;
        margin: 30px 0 10px 0;
      `)}
    `
  }}
`

const ContainerTitle: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const onImpression = useCallback<TrackingFnType>(({ pageMetadata }) => {
    const { id, title } = pageMetadata
    return {
      event: 'article_impression_comment',
      eventCategory: 'article',
      eventLabel: `${id}:${stripHtml(title)}`,
      eventAction: 'impression_comment',
    }
  }, [])

  const trackedOnImpression = useTracking(onImpression)

  const viewportRef = useViewportTracking({
    onImpression: trackedOnImpression,
    track: true,
  })
  return <StyledTitle ref={viewportRef}>{children}</StyledTitle>
}

export default ContainerTitle
